<template>
  <div :class="['szw-text-center szw-w-[128px] szw-font-semibold']">
    {{ loc('sm_form', langId) }}
  </div>
</template>

<script setup>
import { inject } from 'vue'

const langId = inject('langId', '')
</script>
